import { render, staticRenderFns } from "./BaseMenu.vue?vue&type=template&id=ee12d2e8&scoped=true&"
import script from "./BaseMenu.vue?vue&type=script&lang=ts&"
export * from "./BaseMenu.vue?vue&type=script&lang=ts&"
import style0 from "./BaseMenu.vue?vue&type=style&index=0&id=ee12d2e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee12d2e8",
  null
  
)

export default component.exports